"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));
var _ThumbnailBroken = require("../icons/ThumbnailBroken");
var _clsx = _interopRequireDefault(require("clsx"));
var _LiveView = require("../icons/LiveView");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: {
      padding: theme.spacing(2, 0),
      backgroundColor: "rgba(52, 52, 52, 0.0)",
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["6"]),
      borderRadius: 0
    },
    contentWrap: {
      display: "flex",
      justifyContent: "space-between"
    },
    date: {
      color: _pittaModules.LightColors.primary["3"]
    },
    textWrap: {
      maxWidth: function maxWidth(props) {
        return props.mobile ? 208 : "unset";
      }
    },
    img: {
      cursor: "pointer"
    },
    view: {
      fill: "none",
      width: function width(props) {
        return props.mobile ? theme.spacing(8) : theme.spacing(10);
      },
      height: function height(props) {
        return props.mobile ? theme.spacing(8) : theme.spacing(10);
      }
    },
    live: _objectSpread({}, theme.direction === "rtl" ? {
      paddingRight: 3
    } : {
      paddingLeft: 3
    }),
    iconWrap: _objectSpread({
      display: "flex",
      marginTop: 5
    }, theme.direction === "rtl" ? {
      paddingRight: 3
    } : {
      paddingLeft: 3
    }),
    liveWrap: _objectSpread({
      display: "flex",
      width: "max-content",
      color: _pittaModules.LightColors.primary["7"]
    }, theme.direction === "rtl" ? {
      marginLeft: 25
    } : {
      marginRight: 25
    }),
    play: {
      padding: 0,
      color: _pittaModules.LightColors.primary["7"]
    },
    playWrap: {
      display: "flex",
      color: _pittaModules.LightColors.primary["7"]
    },
    button: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      color: _pittaModules.LightColors.primary["7"],
      "&:hover": {
        color: _pittaModules.LightColors.primary["8"]
      },
      "&:active": {
        color: _pittaModules.LightColors.primary["8"]
      }
    },
    buttonDis: {
      cursor: "auto",
      opacity: 0.35,
      "&:hover": {
        color: _pittaModules.LightColors.primary["7"]
      },
      "&:active": {
        color: _pittaModules.LightColors.primary["7"]
      }
    },
    mobileSize: {
      width: theme.spacing(8),
      height: theme.spacing(8)
    }
  });
});
var NotificationListItem = function NotificationListItem(props) {
  var event = props.event,
    disableLiveview = props.disableLiveview,
    disablePlaback = props.disablePlaback,
    utcOffset = props.utcOffset,
    onPlay = props.onPlay,
    onLiveView = props.onLiveView,
    onImage = props.onImage;
  var classes = useStyle(props);
  var theme = (0, _core.useTheme)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgError = _useState2[0],
    setImgError = _useState2[1];
  var getThumbnail = (0, _react.useCallback)(function () {
    if (imgError) {
      return /*#__PURE__*/_react.default.createElement(_ThumbnailBroken.ThumbnailBroken, {
        className: classes.view
      });
    } else if (_lodash.default.includes(_pittaModules.THUMBNAIL_EVENTS, event.msg_code)) {
      return /*#__PURE__*/_react.default.createElement("img", {
        alt: "thumbnail",
        className: (0, _clsx.default)(classes.view, classes.img),
        src: event.img_url,
        onError: function onError() {
          return setImgError(true);
        },
        onClick: function onClick() {
          return onImage === null || onImage === void 0 ? void 0 : onImage(event);
        }
      });
    }
  }, [classes.img, classes.view, event, imgError, onImage]);
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    dir: theme.direction,
    elevation: 0,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentWrap
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    className: classes.date
  }, event.vdate && (0, _moment.default)(event.vdate).utcOffset(utcOffset).format("MMM DD, h:m:ss A")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textWrap
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body"
  }, event.msg)), _lodash.default.includes(_pittaModules.THUMBNAIL_EVENTS, event.msg_code) && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconWrap
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.liveWrap
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.button, disableLiveview && classes.buttonDis),
    onClick: disableLiveview ? undefined : function () {
      return onLiveView === null || onLiveView === void 0 ? void 0 : onLiveView(event);
    }
  }, /*#__PURE__*/_react.default.createElement(_LiveView.LiveView, {
    style: {
      fontSize: 18
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body",
    className: classes.live
  }, "Live view")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.playWrap
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.button, disablePlaback && classes.buttonDis),
    onClick: disablePlaback ? undefined : function () {
      return onPlay === null || onPlay === void 0 ? void 0 : onPlay(event);
    }
  }, /*#__PURE__*/_react.default.createElement(_PlayArrow.default, {
    style: {
      fontSize: 18
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body"
  }, "Playback"))))), getThumbnail()));
};
exports.NotificationListItem = NotificationListItem;